import { Editor } from '@tiptap/core';
import { find } from 'linkifyjs';
import { MarkType, Node } from 'prosemirror-model';
import { Plugin, PluginKey } from 'prosemirror-state';
// import { environment } from '@env/environment';
import { StoreService } from '@utils/store.service';
// import { ChatType } from '@models';

type PasteHandlerOptions = {
    editor: Editor,
    type: MarkType,
    _store?: StoreService
}

const RE = /^\/(chats)\/([A-Z0-9-]{36})(?:\/([A-Z0-9-]{36}))?/i;

export function pasteHandler(options: PasteHandlerOptions): Plugin {
    return new Plugin({
        key: new PluginKey('handlePasteLink'),
        props: {
            handlePaste: (view, _event, slice) => {
                const { state } = view;
                const { selection } = state;
                let textContent = '';
                slice.content.forEach(node => {
                    textContent += node.textContent
                });
                const link = find(textContent).find(item => item.isLink && item.value === textContent);
                if (!textContent || !link) {
                    return false;
                }
                let mention: any;
                // console.log('-[pasteHandler]----------------> link:', link);
                // console.log('-[pasteHandler]----------------> activeOrgId:', activeOrgId);
                // const appBaseUrl = options._store?.getItem('appBaseUrl') || environment.urls.app;
                // if (link.href.startsWith(appBaseUrl)) {
                //     const url = link.href.substring(appBaseUrl.length);
                //     // console.log('-[pasteHandler]----------------> url:', url);
                //     const match = RE.exec(url);
                //     // console.log('-[pasteHandler]----------------> match:', match);
                //     if (match?.[1] == 'chats') {
                //         const id = 'channel|' + match[2] + (match[3] ? '|' + match[3] : '');
                //         const chat = options._store?.getState('chats').items[match[2]];
                //         let label = 'Чат#' + match[2];
                //         if (chat) {
                //             const ids = chat.thread.commentators.map(cm => cm.id!);
                //             label = chat.title;
                //             if (chat.type == ChatType.Direct) {
                //                 if(ids.length == 1 && ids[0] == options._store?.userId) {
                //                     label = 'Избранное';
                //                 }
                //                 else if (ids.length) {
                //                     const persons = options._store?.getState('persons').items;
                //                     label = ids.filter(id => id != options._store?.userId).map(id => persons?.[id]?.name || '#' + id).join(', ');
                //                 }
                //             }
                //         }
                //         mention = { id, label };
                //     }
                //     else if (url.startsWith('/tasks/')) {
                //         let tid = url.substring(7);
                //         if (tid.lastIndexOf('?') > -1) {
                //             tid = tid.substring(0, tid.lastIndexOf('?'));
                //         }
                //         tid = decodeURIComponent(tid);
                //         if (tid.length > 2) {
                //             mention = { id: 'task|' + tid, label: tid };
                //         }
                //     }
                // }
                // console.log('-[pasteHandler]----------------> mention:', mention);
                let node: Node;
                if (mention) {
                    node = state.schema.node(state.schema.nodes.mention, mention).type.create(mention);
                }
                else {
                    node = state.schema.text(link.href, [state.schema.mark('link', { href: link.href })]);
                }
                // console.log('-[pasteHandler]----------------> node:', node);
                const tr = state.tr.replaceWith(selection.from, selection.to, node);
                view.dispatch(tr);
            return true;
            },
        },
    });
}
